import { map } from 'lodash';
import CollectionApi from 'client/api/v2/CollectionApi';
import OrganizationsApi from 'client/api/v2/OrganizationsApi';
import ProvidersApi from 'client/api/v2/ProvidersApi';
import axios from 'axios';

const apiRoute = '/api/v2';

class ManageCommandTemplatesApi extends CollectionApi {
  constructor(providerId = '') {
    super(`${apiRoute}/providers/${providerId}/commandtemplates`, {
      skip: 0,
      limit: 50,
      sort: 'name',
      search: {
        fields: ['name'],
        searchTerm: '',
      },
    });
    this.providerId = providerId;
    this.organizationId = null;
  }

  async fetch(skip, limit, sort, searchTerm, cancelToken, filters = [], pageToken, skipToken) {
    const response = await super.fetch(
      skip, limit, sort, searchTerm, cancelToken, filters, pageToken, skipToken,
    );
    return ManageCommandTemplatesApi.sanitizeResults(response);
  }

  static sanitizeResults(data) {
    const { totalCount } = data;
    let { results } = data;

    results = map(results, (template) => ({
      ...template,
      type: template.commandType, // Need this as type for application
      source: 'Custom',
    }));

    const model = {
      totalCount,
      results,
    };
    return model;
  }

  async get(id, isProvider, cancelToken) {
    const mesg = 'Unable to get item!';
    const Api = isProvider ? ProvidersApi : OrganizationsApi;

    return new Promise((resolve, reject) => {
      Api.initialize()
        .then(() => {
          axios
            .get(`${this.baseUrl}/${id}`, { cancelToken })
            .then((resp) => {
              if (resp && resp.data) {
                resolve(resp.data);
              } else {
                Api.handleError(reject, mesg);
              }
            })
            .catch((error) => {
              Api.handleError(reject, mesg, error);
            });
        })
        .catch((error) => {
          Api.handleError(reject, mesg, error);
        });
    });
  }

  setProviderId(providerId = '') {
    this.baseUrl = `${apiRoute}/providers/${providerId}/commandtemplates`;
    this.providerId = providerId;
  }

  setOrganizationId(organizationId = '') {
    this.organizationId = organizationId;
  }
}

export default new ManageCommandTemplatesApi();
